module.exports = __webpack_public_path__ + "5a3dde7b47cfce3237937dfe49491ead.pdf";